import * as z from 'zod/v4';

export const errorResponse = z.object({
	success: z.literal(false),
	message: z.string()
});

export const successResponse = z.object({
	success: z.literal(true)
});

export interface ErrorsResponse {
	messages: string[];
	path: string;
	type: string;
}

export interface ErrorResponse {
	success: false;
	errors?: ErrorsResponse[];
	message: string;
}

export class ErrorApiResponse extends Error {
	success: false;
	errors: ErrorsResponse[] | undefined;
	statusCode: number;

	constructor(message: string, statusCode: number, error?: ErrorsResponse[]) {
		super(message);
		this.name = 'ErrorApiResponse';
		this.success = false;
		this.statusCode = statusCode;
		this.errors = error;
	}
}

export class ErrorApiResponseWithData<TData> extends Error {
	success: false;
	errors: ErrorsResponse[] | undefined;
	statusCode: number;
	data: TData | undefined;

	constructor(
		message: string,
		statusCode: number,
		error?: ErrorsResponse[],
		data?: TData
	) {
		super(message);
		this.name = 'ErrorApiResponseWithData';
		this.success = false;
		this.statusCode = statusCode;
		this.errors = error;
		this.data = data;
	}
}

export type DataTableResponse<T> = {
	success: true,
	data: T[],
	count: number
};

export type SuccessResponse<T> = {
	success: true,
	data: T
};
